<template>
  <div class="page">
    <!-- 页头 -->
    <home-header currentMenuId="3"></home-header>

    <!-- 内容 -->
    <div class="content-box">
      <!-- 第一模块 -->
      <div class="f-module">
        <div class="left-box">
          <h2 class="title">内部资产高效管理</h2>
          <span class="text">完善的资产管理平台，沉淀内部开发文档和美术资源，高效管理企业资产</span>
        </div>
        <div class="right-box pc_right">
          <img src="../img/home/home-3.png" />
        </div>
        <div class="right-box mb_right">
          <img src="../img/home/s_bg.png" class="bg_img" />
          <img src="../img/home/s_img.png" class="data_img" />
        </div>
      </div>

      <!-- 第三模块 -->
      <div class="module t-module pc-module">
        <h2 class="title">产品介绍</h2>
        <div class="box">
          <div class="left-box">
            <div class="t-item" v-for="(item,index) in productList" :key="index">
              <div class="t-item-title" v-if="currentProduct.title !== item.title" @mouseenter="mouseEnter(item,index)">
                <i class="circle"></i>
                <div class="name">{{item.title}}</div>
              </div>
              <div class="desc-box" v-else>
                <div class="desc-title">
                  <i class="circle"></i>
                  <div class="name">{{item.title}}</div>
                </div>
                <div class="desc">{{item.desc}}</div>
                <a :href="item.link" target="_blank" class="butn">开始使用</a>
              </div>
            </div>
          </div>
          <div class="right-box">
            <img class="img" :src="currentProduct.img">
          </div>
        </div>
      </div>

      <div class="module t-module mb-module">
        <h2 class="title">产品介绍</h2>

            <!-- <el-tabs :stretch="true">
                <el-tab-pane :label="item.title" v-for="(item,index) in productList" :key="index"> -->
                    <div  v-for="(item,index) in productList" :key="index">
                        <div class="p_title">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                        <img class="img" :src="item.img">
                    </div>
                <!-- </el-tab-pane>
            </el-tabs> -->
      </div>
    </div>

    <!-- 浮层 -->
    <home-suspend></home-suspend>

    <!-- 页脚 -->
    <home-footer></home-footer>
  </div>
</template>

<script>
import HomeHeader from '../components/header'
import HomeFooter from '../components/footer'
import HomeSuspend from '../components/suspend'
import Link from '../components/link'
export default {
  components: { HomeHeader, HomeFooter, HomeSuspend },
  data() {
    return {
      productList: [
        {
          title: '美术平台',
          desc: '内部美术资源分享和管理平台，为游戏、市场、宣发提供全面丰富的素材资源和素材分析服务',
          img: require('../img/home/resource.png'),
          link: Link.Arts
        }
      ],
      currentProduct: {}
    }
  },
  created() {
    this.currentProduct = this.productList[0]
  },
  methods: {
    // 移入
    mouseEnter(item) {
      this.currentProduct = item
    }
  }
}
</script>

<style lang="scss" scoped>
.content-box {
  margin-top: 72px;
}
.f-module {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left-box {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
  }
  .title {
    margin: 0;
    font-size: 42px;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
  }
  .text {
    font-size: 20px;
    color: #666666;
    line-height: 1.2;
    margin-top: 20px;
  }

  img {
    display: block;
    width: auto;
    height: 500px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
}
.f-module {
  height: 400px;
  overflow: hidden;
  background: linear-gradient(131deg, #ffffff 30%, #e3ecf6 200%);
}
.f-module {
  padding-left: 9vw;
  .left-box {
    align-items: flex-start;
    margin-right: 4vw;
  }
  .mb_right {
    display: none;
  }
  .pc_right {
    display: inline-flex;
  }
  .right-box {
    flex-shrink: 0;
    min-width: 770px;
    width: 50vw;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
}

.module {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .title {
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
  }
  .text {
    margin-top: 16px;
    font-size: 18px;
    color: #999999;
    line-height: 1.2;
  }
}
.pc-module {
    display: flex !important;
  }
  .mb-module {
    display: none !important;
  }
.t-module {
  height: 650px;
  background: #f1f9ff;
  .box {
    margin-top: 60px;
    width: 100%;
    padding: 0 0px 0 80px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
  .pc_right {
      display: inline-block;
    }
    .mb_right {
      display: none;
    }
  .left-box {
    flex-grow: 1;
    width: 30vw;
    margin: 0 4.5vw 0 3.5vw;
  }
  .right-box {
    flex-shrink: 0;
    min-width: 740px;
    width: 52vw;
    .img {
      width: 650px;
      height: 350px;
    }
  }
  .t-item {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    .t-item-title {
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      transition: height 0.3s ease-in-out;
      cursor: pointer;
      margin-bottom: 16px;
    }
    .circle {
      width: 10px;
      height: 10px;
      background: #dddddd;
      border-radius: 100%;
      margin-right: 40px;
    }
    .name {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 26px;
    }
    .desc-box {
      width: 100%;
      height: auto;
      margin-left: 50px;
      margin-bottom: 26px;
      transition: height 0.35s ease-in-out;
      .desc-title {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin-left: -50px;
        cursor: pointer;
      }
      .circle {
        background: #3a89ff;
      }
      .name {
        font-size: 32px;
        font-weight: 500;
        color: #333333;
        line-height: 46px;
      }

      .desc {
        //display: none;
        margin-top: 24px;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
        line-height: 1.4;
      }

      .butn {
        display: block;
        margin-top: 24px;
        width: 88px;
        height: 36px;
        background: #3a89ff;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
        cursor: pointer;
        // transition: all 0.3s;

        &:hover {
          opacity: 0.8;
          // transform: translate3d(5px, 5px, 0);
        }
      }
    }
  }
}
</style>


<style lang="scss" scoped>
/*小于等于1240px */
@media (max-width: 1240px) {
  .content-box {
    min-width: 375px;
  }
  .pc-module {
    display: none !important;
  }
  .mb-module {
    display: block !important;
  }
  .module {
    display: block;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: center;
    width: 100%;
    text-align: center;

    .left-box {
      display: block;
      // flex-flow:;
      // justify-content: center;
    }
    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 60px;
    }
    .text {
      font-size: 13px;
      color: #666666;
      line-height: 1.4;
      margin-top: 20px;
    }
    .butn-box {
      text-align: center;
      display: block;

      .butn {
        display: inline-block;
      }
      .link_butn {
        display: none;
      }
    }
  }
  .f-module {
    display: inline-block;
    width: 100%;
    text-align: center;
    height: auto;
    padding: 30px 5% 0px 5%;
    position: relative;

    .left-box {
      display: inline-block;
      margin-right: auto;
      .butn {
        display: none;
      }

      .title {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        line-height: 60px;
      }
      .text {
        font-size: 13px;
        color: #666666;
        line-height: 1.4;
        margin-top: 20px;
      }
    }
    .pc_right {
      display: none;
    }
    .mb_right {
      display: inline-block;
    }
    .right-box {
    //   display: inline-block;
      min-width: auto;
      width: 100%;
      align-items: initial;
      height: auto;
    //   overflow:auto;
      position:initial;

      .bg_img {
        position: absolute;
        right: -5vw;
        bottom: 0;
        left: 10%;
        width: 90%;
        height: 65%;
        top: auto;
      }
      .data_img {
        width: 100%;
        position: relative;
        z-index: 3;
        height: auto;
      }
    }
  }


  .t-module {
    height: auto;
    padding: 30px 0% 20px 0%;
    position: relative;
    background: linear-gradient(131deg, #ffffff 30%, #e3ecf6 140%);
    .pc_right {
      display: none;
    }
    .mb_right {
      display: inline-block;
    }

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 500;
      color: #333;
      line-height: 60px;
    }

    ::v-deep .el-tabs__item {
      padding: 0 !important;
      font-size: 12px;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      opacity: 0.3;
    }

    .p_title{
        font-size: 14px;
    }

    .desc {
      padding: 10px 5%;
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }

    .img {
      width: 90%;
    }
  }
}
</style>